/* eslint-disable */
/* oxlint-disable */
/* prettier-ignore-file */
// @ts-nocheck
// This file is auto-generated. Do not edit manually.
// Run 'pnpm codegen' to regenerate this file.

export type PswapOrderSide =
  | 'Long'
  | 'Short';
export type PswapOrderSideJsonValue = PswapOrderSide;
export const PswapOrderSide_values: PswapOrderSide[] = ['Long', 'Short'];
export function PswapOrderSide_fromJsonValue(json: PswapOrderSideJsonValue): PswapOrderSide {
  return json as PswapOrderSide;
}
export function PswapOrderSide_toJsonValue(value: PswapOrderSide): PswapOrderSideJsonValue {
  return value;
}

export type OrderAction =
  | 'Open'
  | 'Close';
export type OrderActionJsonValue = OrderAction;
export const OrderAction_values: OrderAction[] = ['Open', 'Close'];
export function OrderAction_fromJsonValue(json: OrderActionJsonValue): OrderAction {
  return json as OrderAction;
}
export function OrderAction_toJsonValue(value: OrderAction): OrderActionJsonValue {
  return value;
}

export type OrderTriggerDirection =
  | 'Up'
  | 'Down';
export type OrderTriggerDirectionJsonValue = OrderTriggerDirection;
export const OrderTriggerDirection_values: OrderTriggerDirection[] = ['Up', 'Down'];
export function OrderTriggerDirection_fromJsonValue(json: OrderTriggerDirectionJsonValue): OrderTriggerDirection {
  return json as OrderTriggerDirection;
}
export function OrderTriggerDirection_toJsonValue(value: OrderTriggerDirection): OrderTriggerDirectionJsonValue {
  return value;
}

export type OrderTriggerPriceType =
  | 'LAST'
  | 'MARK';
export type OrderTriggerPriceTypeJsonValue = OrderTriggerPriceType;
export const OrderTriggerPriceType_values: OrderTriggerPriceType[] = ['LAST', 'MARK'];
export function OrderTriggerPriceType_fromJsonValue(json: OrderTriggerPriceTypeJsonValue): OrderTriggerPriceType {
  return json as OrderTriggerPriceType;
}
export function OrderTriggerPriceType_toJsonValue(value: OrderTriggerPriceType): OrderTriggerPriceTypeJsonValue {
  return value;
}

export type ConditionalOrderType =
  | 'CONDITIONAL_ORDER_TYPE_INVALID'
  | 'CONDITIONAL_ORDER_TYPE_POSITION_TP'
  | 'CONDITIONAL_ORDER_TYPE_POSITION_SL'
  | 'CONDITIONAL_ORDER_TYPE_ORDER_TP'
  | 'CONDITIONAL_ORDER_TYPE_ORDER_SL';
export type ConditionalOrderTypeJsonValue = ConditionalOrderType;
export const ConditionalOrderType_values: ConditionalOrderType[] = ['CONDITIONAL_ORDER_TYPE_INVALID', 'CONDITIONAL_ORDER_TYPE_POSITION_TP', 'CONDITIONAL_ORDER_TYPE_POSITION_SL', 'CONDITIONAL_ORDER_TYPE_ORDER_TP', 'CONDITIONAL_ORDER_TYPE_ORDER_SL'];
export function ConditionalOrderType_fromJsonValue(json: ConditionalOrderTypeJsonValue): ConditionalOrderType {
  return json as ConditionalOrderType;
}
export function ConditionalOrderType_toJsonValue(value: ConditionalOrderType): ConditionalOrderTypeJsonValue {
  return value;
}

export type OrderType =
  | 'ORDER_TYPE_INVALID'
  | 'ORDER_TYPE_MARKET'
  | 'ORDER_TYPE_LIMIT'
  | 'ORDER_TYPE_STOP_MARKET'
  | 'ORDER_TYPE_STOP_LIMIT';
export type OrderTypeJsonValue = OrderType;
export const OrderType_values: OrderType[] = ['ORDER_TYPE_INVALID', 'ORDER_TYPE_MARKET', 'ORDER_TYPE_LIMIT', 'ORDER_TYPE_STOP_MARKET', 'ORDER_TYPE_STOP_LIMIT'];
export function OrderType_fromJsonValue(json: OrderTypeJsonValue): OrderType {
  return json as OrderType;
}
export function OrderType_toJsonValue(value: OrderType): OrderTypeJsonValue {
  return value;
}

export type TpslOrderType =
  | 'TPSL_ORDER_TYPE_INVALID'
  | 'TPSL_ORDER_TYPE_MARKET'
  | 'TPSL_ORDER_TYPE_LIMIT';
export type TpslOrderTypeJsonValue = TpslOrderType;
export const TpslOrderType_values: TpslOrderType[] = ['TPSL_ORDER_TYPE_INVALID', 'TPSL_ORDER_TYPE_MARKET', 'TPSL_ORDER_TYPE_LIMIT'];
export function TpslOrderType_fromJsonValue(json: TpslOrderTypeJsonValue): TpslOrderType {
  return json as TpslOrderType;
}
export function TpslOrderType_toJsonValue(value: TpslOrderType): TpslOrderTypeJsonValue {
  return value;
}

export type PriceMatchStrategy =
  | 'PRICE_MATCH_STRATEGY_COUNTERPARTY_1';
export type PriceMatchStrategyJsonValue = PriceMatchStrategy;
export const PriceMatchStrategy_values: PriceMatchStrategy[] = ['PRICE_MATCH_STRATEGY_COUNTERPARTY_1'];
export function PriceMatchStrategy_fromJsonValue(json: PriceMatchStrategyJsonValue): PriceMatchStrategy {
  return json as PriceMatchStrategy;
}
export function PriceMatchStrategy_toJsonValue(value: PriceMatchStrategy): PriceMatchStrategyJsonValue {
  return value;
}
